import React, { useRef, useState, useEffect } from "react";
import { Cookies } from "react-cookie";
import {
    Div,
    Divider,
    FlexColumn,
    FlexRow,
    Spacer,
} from "../../../core/Containers";
import { Text } from "../../../core/Text";
import { LBCModal } from "../../../components/Modals/LBCModal";
import { ColumnHeader } from "../../../components/Tables/ColumnHeader";
import { SendTipidDataRow } from "../../../components/Tables/DeliveryDataRow";
import { Pagination } from "../../../components/Tables/Pagination";
import { ImSpinner2 } from "react-icons/im";
import axiosCAPApiPrivate from "../../../api/axiosCAPApiPrivate";

const cookies = new Cookies();

export const SendTipidTab = ({ dateFrom, dateTo }) => {
    const dataFetchedRef = useRef(false);

    const [accountActivities, setAccountActivities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [articlesPerPage] = useState(5);
    const [shipperAcctName, setShipperAcctName] = useState("");
    const [shipperAcctNo, setShipperAcctNo] = useState("");
    const [isToastOpen, setToastOpen] = useState(false);
    const [toastKind, setToastKind] = useState("");
    const [toastTitle, setToastTitle] = useState("");
    const [toastDesc, setToastDesc] = useState("");
    const [reportDetail, setReportDetail] = useState([]);
    const [deliveryStatus, setDeliveryStatus] = useState("SendTipid");

    // Paginate variables
    const indexOfLastArticle = currentPage * articlesPerPage;
    const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
    const newItems = reportDetail.slice(indexOfFirstArticle, indexOfLastArticle);

    // Paginate function
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const userInfo = cookies.get("userInfo", { path: "/" });

    // Get Shippert Account from cookies
    const getShipperAccountFromCookies = () => {
        const _shipperAcct = cookies.get("shipperAcct", { path: "/" });
        if (!_shipperAcct) return { name: "", no: "" };

        const [name, no] = _shipperAcct.split("|");
        return { name: name?.trim() || "", no: no?.trim() || "" };
    };

    // Fetch booking details API
    const getBookingDetails = async (shipperAccountNo) => {
        setReportDetail([]);
        setLoading(true);

        const reqData = {
            customerAccountNo: shipperAccountNo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            transactionStatus: "ACTIVE",
        };

        console.log(reqData);

        try {
            const response = await axiosCAPApiPrivate.post(
                `/api/GetSendTipidDetails`,
                reqData
            );

            const resData = response.data;

            if (resData.Code === "200") {
                console.log(resData.Data);
                setReportDetail(resData.Data);
                setLoading(false);
            } else {
                setToastKind("error");
                setToastTitle("API Fetch Failed!");
                setToastDesc(resData.Message);
                setLoading(false);
                setToastOpen(true);
            }
        } catch (error) {
            setToastKind("error");
            setToastTitle("API Fetch Failed!");
            setToastDesc(error.message);
            setLoading(false);
            setToastOpen(true);
        }
    };

    // Load shipper account on component mount or when cookies change
    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        const { name, no } = getShipperAccountFromCookies();
        setShipperAcctName(name);
        setShipperAcctNo(no);
        getBookingDetails(no);
    }, []);

    // Re-fetch when shipperAcct changes
    useEffect(() => {
        const { name, no } = getShipperAccountFromCookies();
        setShipperAcctName(name);
        setShipperAcctNo(no);
        getBookingDetails(no);
    }, [cookies.get("shipperAcct", { path: "/" })]);

    // Fetch when date filters change
    useEffect(() => {
        if (shipperAcctNo) {
            getBookingDetails(shipperAcctNo);
        }
    }, [dateFrom, dateTo, shipperAcctNo]);

    const onSort = (column) => {
        setLoading(true);
    };

    return (
        <>
            <LBCModal
                id="alertModal"
                description={toastDesc}
                isOpen={isToastOpen}
                onClose={() => setToastOpen(false)}
                title={toastTitle}
                toastKind={toastKind}
            />

            <Div className="w-full">
                <Spacer className="w-full h-10" />
                <Div className="w-full border border-grey-400 rounded-lg shadow-lg">
                    <FlexRow className="items-center justify-between py-2 pl-2 border border-grey-400">
                        <Text className="text-secondary-100 text-xs text-left font-semibold w-40 px-2 py-2">
                            Reference No
                        </Text>
                        <ColumnHeader
                            title="Requested By"
                            onClick={() => onSort(0)}
                            containerClass="justify-start hover:bg-grey-400 rounded-full w-40 px-2 py-2"
                            titleClassName=""
                        />
                        <ColumnHeader
                            title="Approver Team"
                            onClick={() => onSort(0)}
                            containerClass="justify-start hover:bg-grey-400 rounded-full w-40 px-2 py-2"
                            titleClassName=""
                        />
                        <ColumnHeader
                            title="Status"
                            onClick={() => onSort(0)}
                            containerClass="justify-start hover:bg-grey-400 rounded-full w-1/6 px-2 py-2"
                            titleClassName=""
                        />
                        <ColumnHeader
                            title="Requested Date"
                            onClick={() => onSort(0)}
                            containerClass="justify-start hover:bg-grey-400 rounded-full w-1/6 px-2 py-2"
                            titleClassName=""
                        />
                    </FlexRow>
                    {/* <Divider className="text-grey-100 my-2 w-2800px" /> */}

                    {loading ? (
                        <Text className="text-red-400 text-center flex flex-row justify-center items-center my-20">
                            <ImSpinner2 className="animate-spin mr-2 text-2xl desktop:text-3xl" />
                            Loading data ...
                        </Text>
                    ) : (
                        <>
                            {newItems.map((item, key) => (
                                <SendTipidDataRow data={item} key={key} />
                            ))}
                        </>
                    )}
                </Div>
                <Spacer className="w-full h-10" />
                <Div className="w-full">
                    <Pagination
                        currentPage={currentPage}
                        itemsPerPage={articlesPerPage}
                        paginate={paginate}
                        totalItems={reportDetail.length}
                    />
                </Div>
            </Div>
        </>
    );
};